module.exports = __webpack_public_path__ + "img/moren.72858917.png";